import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import { connect, useDispatch, useSelector } from "react-redux";
import { getAuthData, getSessinIdFromLS } from "../../../services/storage/LocalStorage";
import {
    chatinwindowscriptSrc, loadBotScriptStyles, removeChatInWindowScript, sendParamsToEmbeddedChatbot
} from "../../../utils/ChatbotScriptHelpers";
import { setInitializeChatInWindow, setShowChatInWindow } from "../../../state/actions/chats";
import { appType } from "../../../utils/config/configHelpers";
import { createConversationId } from "../../../utils/conversationUtils";
import { processSendMessage } from "../../../services/bot/conversation/SendMessage";


const FMChatInWindow = ({connectionId,refreshToken}) => {
    const chatInWindowData = useSelector((state) => state.chats.chatInWindowData);
    const selectedBotDetails = useSelector((state) => state.domain.selectedBotDetails);
    const chatInWindowOpen = useSelector((state) => state.chats.chatInWindowOpen);
    const initializechatInWindow = useSelector((state) => state.chats.initializechatInWindow);

    const nodeRef = useRef(null)
    const dispatch = useDispatch();
    const sessionId = getSessinIdFromLS();

    const userDetail = getAuthData();
    const userData = userDetail?.user || {};

    const [mainMenuToggle, setMainMenuToggle] = useState(false);
    const [showChatWindow, setShowChatWindow] = useState(true);

    const styleId = "chatbot-as-chatinwindow-styles";
    const stylePath = "/scripts/chatInWindow/css/main.5802ba76.css";


    useEffect(() => {
        window.CurrentEnvironement = process.env.REACT_APP_ENV || 'development';
        if (selectedBotDetails && chatInWindowOpen) {
            performCleanupAndLoad();
        }
    }, [selectedBotDetails, chatInWindowOpen]);


    const performCleanupAndLoad = async () => {
        // const response = await fullBotScriptReset(null, true);
        // if (response === true) {
        setTimeout(() => {
            loadBotScriptStyles(styleId, stylePath);
            loadBotScript();
        }, 300);
        // }
    };

    const loadBotScript = () => {
        const existingScript = document.querySelector(`script[src="${chatinwindowscriptSrc}"]`);

        if (existingScript) {
            // console.log('Script already loaded for chatwidget, removing and reloading...');
            removeChatInWindowScript();
        }

        setTimeout(() => {
            const script = document.createElement('script');
            script.src = chatinwindowscriptSrc;
            script.async = true;
            script.onload = () => {
                // console.log("Chatwidget Script loaded successfully.");
                setTimeout(async () => {
                    const conversationId = await createConversationId(userData.userId, selectedBotDetails?.botId);
                    console.log("selectedBotDetails : ===> ", selectedBotDetails)
                    const params = {
                        isChatInWindow: true,
                        userEmail: userData.emailAddress || "",
                        sessionId: sessionId || userDetail?.auth?.sessionId,
                        appType: appType,
                        conversationId: conversationId || "",
                        platform: "web",
                        botId: selectedBotDetails?.botId || "",
                        botName: selectedBotDetails?.botName || "",
                        botLogoUrl: selectedBotDetails?.logoUrl || "",
                        hideAudioIcon: true,
                        chatInWindowFirstMessage: chatInWindowData,
                        refreshToken:refreshToken,
                        connectionId: connectionId
                    };

                    sendParamsToEmbeddedChatbot(params);
                }, 200);
            };
            script.onerror = (e) => {
                console.error("Error loading the script: ", e);
                setLoader(false)
            };
            document.body.appendChild(script);
        }, 100);
    };

   const handleCloseClick = () => {
        dispatch(setShowChatInWindow(false, null));
        dispatch(setInitializeChatInWindow(null));
        const responseChat = {
            "messageType": "chatResponse",
            "message": {
                "action": "closeChat",
                "content": {},
                "controlId": chatInWindowData?.options?.controlId,
                "participant": {
                    "bot": chatInWindowData?.bot,
                    "chatConversationId": chatInWindowData?.options?.chatConversationId,
                    "userEmail":  userData?.emailAddress,
                    "userId": userData?.userId,
                    "userName": userData?.userName
                },
                "tabId": chatInWindowData?.options?.tabId
            },
            "messageId": chatInWindowData?.messageId
        }

        processSendMessage(responseChat);

        try {
            if (typeof window.destroyChatWidget === "function") {
                window.destroyChatWidget();
            }
        } catch (err) {
            console.warn("Error while calling destroyChatBot script:", err);
        }
    };

    const handleHideChatWindow = () => {
        setShowChatWindow(false);
        setMainMenuToggle(true);
    };

    const handleShowChatWindow = () => {
        setShowChatWindow(true);
        setMainMenuToggle(false);
    };

    return (
        <Draggable handle=".chat-modal-header" nodeRef={nodeRef}>
            <div
                ref={nodeRef}
                className="fixed top-[100px] left-[100px] z-[1000] w-[400px] rounded-lg shadow-lg bg-white"
            >
                <div className="flex flex-col overflow-hidden rounded-[10px] bg-white shadow-shd-on">
                    {/* Header */}
                    <div>
                        <div
                            className="chat-modal-header flex items-center cursor-move border-b border-[#dedede] px-3 py-[18px]"
                        >
                            <div className="flex-grow text-[16px] font-bold mr-7">
                                {initializechatInWindow?.options?.title || chatInWindowData?.options?.title || ""}
                            </div>

                            {!mainMenuToggle ? (
                                <div
                                    className="menu-circle-bg mr-2 cursor-pointer"
                                    onClick={handleHideChatWindow}
                                >
                                    <img
                                        src="/img/maximize-icon@3x.png"
                                        alt="maximize-icon"
                                    />
                                </div>
                            ) : (
                                <div
                                    className="menu-circle-bg-open me-2 cursor-pointer"
                                    onClick={handleShowChatWindow}
                                >
                                    <img
                                        src="/img/minimize-icon@3x.png"
                                        alt="minimize-icon"
                                    />
                                </div>
                            )}

                            <div
                                className="menu-circle-bg-open cursor-pointer"
                                onClick={() => handleCloseClick()}
                            >
                                <img
                                    src="/img/close-icon@3x.png"
                                    alt="close-icon"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Chatbot Container */}
                    <div className="flex-1 bg-white">
                        <div
                            id="chat-bot-project-root"
                            className={`transition-all duration-300 ease-in-out transform
                             ${showChatWindow ? "opacity-100 scale-100 block" : "opacity-0 scale-95 hidden"}`}
                            style={{ width: "100%", height: "100%" }}
                        />
                    </div>
                </div>
            </div>
        </Draggable>
    );
};

export default FMChatInWindow;